<template>
  <div class="typeList">
    <el-card>
      <el-button type="primary" slot="header" @click="jump">{{$t('lang.addtypeBtn')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight609 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.typeListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column :label="$t('lang.lab_typename')" prop="name" width="380px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.name&&scope.row.name.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span>{{ scope.row.name }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.name.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.name.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="url" :label="$t('lang.lab_Goformorestyle')">
          <template slot-scope="scope">
            <img :src="scope.row.urls" height="24px" />
          </template>
        </el-table-column>
        <el-table-column prop="signType" :label="$t('lang.lab_Signinway')">
          <template slot-scope="scope">
            <span v-if="scope.row.signType === 1">{{$t('lang.TYPE.SIGN[0].label')}}</span>
            <span v-if="scope.row.signType === 2">{{$t('lang.TYPE.SIGN[1].label')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          :width="require('@/config/enum').opr_width2"
        >
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="title"
      @closed="handleDialogClosed"
    >
    
        <el-form
          :rules="rules"
          ref="form"
          :model="form"
          :label-width="require('@/config/enum').c_ws4"
          :label-suffix="require('@/config/enum').c_colon"
        >
          <el-form-item :label="$t('lang.lab_typenames')" prop="name">
            <el-input v-model="form.name" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_styles')" prop="url">
            <template>
              <el-radio
                v-model="form.url"
                v-for="check in urlList"
                :label="check.url"
                :key="check.url"
              >
                <img :src="check.id" height="30px" />
              </el-radio>
            </template>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_Signinways')">
            <el-select class="select" v-model="form.signType" placeholder>
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      
      <div slot="footer">
        <el-button @click="handleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button
          type="primary"
          :disabled="isDisabled"
          @click="onSubmit('form')"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 *@ClassName:typeList
 *@Description:类型设置
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-02-29
 */
export default {
  data() {
    return {
      title: this.$i18n.t('lang.modifytype'), // 切换修改新增title
      id: '', // 区分新增和修改
      saveData: '', // 存储json字符串
      isDisabled: true, // 确定按钮置灰
      show: false, // 弹框开关
      form: {
        name: '',
        url: '/images/patrol/pink.png',
        signType: 1
      }, // 通过id查询对象
      status: this.$i18n.t('lang.TYPE.SIGN'), // 下拉
      multipleSelection: [], // 多选框
      urlList: [
        {
          id: require('../../../../images/patrol/pink.png'),
          url: '/images/patrol/pink.png'
        },
        {
          id: require('../../../../images/patrol/blue.png'),
          url: '/images/patrol/blue.png'
        },
        {
          id: require('../../../../images/patrol/green.png'),
          url: '/images/patrol/green.png'
        },
        {
          id: require('../../../../images/patrol/yellow.png'),
          url: '/images/patrol/yellow.png'
        },
        {
          id: require('../../../../images/patrol/red.png'),
          url: '/images/patrol/red.png'
        }
      ],
      pageCount: 0, // 总页数
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 查询list
      typeListcheckbox: require('@/config/enum').typeListcheckbox, // 是否隐藏复选框
      rules: {
        name: [
          {
            required: true,
            message: this.$i18n.t('lang.typenames'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.list()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.form.name = ''
      this.form.url = '/images/patrol/pink.png'
      this.form.signType = 1
      this.$refs.form.clearValidate()
    },
    // CHECKBOX
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 类型列表
    list() {
      let loading = this.$loading()
      this.$get(
        `/patrolType?GardenId=${this.$store.getters.gardenId}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].url === '/images/patrol/pink.png') {
                this.tableData[i].urls = require('../../../../images/patrol/pink.png')
              } else if (this.tableData[i].url === '/images/patrol/blue.png') {
                this.tableData[i].urls = require('../../../../images/patrol/blue.png')
              } else if (this.tableData[i].url === '/images/patrol/green.png') {
                this.tableData[i].urls = require('../../../../images/patrol/green.png')
              } else if (
                this.tableData[i].url === '/images/patrol/yellow.png'
              ) {
                this.tableData[i].urls = require('../../../../images/patrol/yellow.png')
              } else if (this.tableData[i].url === '/images/patrol/red.png') {
                this.tableData[i].urls = require('../../../../images/patrol/red.png')
              }
            }
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    // 通过id查询详情对象
    edit(id) {
      this.title = this.$i18n.t('lang.modifytype')
      this.id = id
      let loading = this.$loading()
      this.$get(`/patrolTypeById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form = res.patrolType
            this.saveData = JSON.stringify(this.form)
            this.show = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 新增
    jump() {
      this.show = true
      this.id = ''
      this.title = this.$i18n.t('lang.addtypeBtn')
    },
    // 查询按钮
    commit() {
      this.pageNum = 1
      this.list()
    },
    // 修改保存
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id === '') {
             let params = {
              Name: this.form.name,
              Url: this.form.url,
              GardenId: this.$store.getters.gardenId,
              SignType: this.form.signType
            }
            let loading = this.$loading()
            this.$postJson(`/patrolType/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.commit()
                  this.show = false
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let params = {
              Name: this.form.name,
              Url: this.form.url,
              SignType: this.form.signType
            }
            let loading = this.$loading()
            this.$patch(`/patrolType/${this.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(
                    this.$i18n.t('lang.lab_modify_success')
                  )
                  this.commit()
                  this.show = false
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
    // 删除
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`/patrolType/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
 .el-tooltip__popper.is-light {
  max-width: 300px;
 }
</style>
